import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UsersService } from 'src/app/features/users/services/users.service';

@Injectable({ providedIn: 'root' })
export class UniqueDocumentLaftValidator {
  constructor(private usersService: UsersService) {}

  public isUniqueDocument(currentIdNumber?: string): AsyncValidatorFn {
    return (control: AbstractControl) => {
      return new Promise((resolve, reject) => {
        const idType = control.parent.get('idType').value;

        return timer(0)
          .pipe(switchMap(() => this.usersService.checkIdentityExists(idType, control.value, currentIdNumber)))
          .subscribe(
            res => {
              resolve(null);
            },
            err => {
              resolve({ isUniqueDocument: true });
            }
          );
      });
    };
  }
}
